import { Box } from '@mui/system';

const CustomTab = ({ children, value, index }) => {
  return (
    <Box
      className="mapInfoConArea"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
    >
      {children}
    </Box>
  );
};

export default CustomTab;
